import {
  ChallengeShell,
  ChoiceGrid,
  useChoices,
  usePickHandler,
  type ChallengeProps,
} from "./shared";

/** Read English, pick the Vietnamese translation. */
export function EnglishToVietnamese({ word, distractors, onAnswer }: ChallengeProps) {
  const { picked, handle, teachOverlay, celebrateOverlay, retryKey } = usePickHandler(word, onAnswer);
  const choices = useChoices(word, distractors, retryKey);

  return (
    <>
      <ChallengeShell
        tag="Translate"
        prompt={`What does "${word.english}" mean?`}
        speakerText={word.english}
        speakerAudioUrl={word.audioUrl}
        speakerVietnamese={word.vietnamese}
      >
        <ChoiceGrid
          choices={choices}
          correctId={word.id}
          picked={picked}
          onPick={handle}
          render={(c) => <span className="choice-vi">{c.vietnamese}</span>}
        />
      </ChallengeShell>
      {teachOverlay}{celebrateOverlay}
    </>
  );
}
